import { ComponentRef } from '@angular/core';
import { TemplateContext } from '../../../../models/reportTemplate.model';
import { PpeTemplateData } from '../../../../models/ppeTemplateData.model';
import { IhLabResult } from '../../../../models/IhLabResult.model';
import { SampleTypeEnum } from '../../../../enums/sampleType.enum';
import { SampleGravimetricData } from '../gravimetric-widget/gravimetric-widget.component';
import { EditorPropertySchema, EditorRenderStrategy } from '../widget-config.helpers';
import { PpeListWidgetComponent } from './ppe-list-widget.component';

interface PpeListContext extends TemplateContext {
    sample?: { isVoid?: boolean; sampleType?: number | SampleTypeEnum; ihLabResults?: IhLabResult[] };
    ppeAssignments?: PpeTemplateData[];
    computedData?: { gravimetricData?: SampleGravimetricData };
}

export function configurePpeListWidget(
    componentRef: ComponentRef<unknown>,
    context: TemplateContext
): void {
    const component = componentRef.instance as PpeListWidgetComponent;
    const ctx = context as PpeListContext;
    const gravimetricSample = ctx.computedData?.gravimetricData?.sample;

    component.ppeAssignments = ctx.ppeAssignments || [];
    component.ihLabResults = gravimetricSample?.ihLabResults || ctx.sample?.ihLabResults || [];
    component.sampleType = (gravimetricSample?.sampleType ?? ctx.sample?.sampleType ?? SampleTypeEnum.Air) as SampleTypeEnum;
    component.isVoid = !!(ctx.sample?.isVoid);
}

export const ppeListEditorPropertySchema: EditorPropertySchema = {
    renderStrategy: EditorRenderStrategy.ReadOnly,
    propertySchema: []
};

export const ppeListLoopTemplate = [
    '<div class="ppe-widget" style="display:flex;flex-direction:column;gap:16px;">',
    '<div class="ppe-content" style="display:grid;grid-template-columns:repeat(auto-fit,minmax(250px,1fr));gap:16px;">',
    '[[#each ppeAssignments]]',
    '<div class="ppe-item" style="display:flex;gap:12px;padding:16px;background:#fff;border:1px solid #e8e6f0;border-radius:12px;align-items:center;">',
    '<img class="ppe-icon" src="[[this.iconUrl]]" style="width:48px;height:48px;object-fit:contain;" />',
    '<div class="ppe-details" style="flex:1;display:flex;flex-direction:column;gap:4px;">',
    '<div class="ppe-model" style="font-weight:600;font-size:14px;color:#333;">[[this.modelName]]</div>',
    '[[#if this.rating]]<div class="ppe-protection-factor" style="font-size:12px;color:#6c63ff;font-weight:600;">[[this.rating]] ([[this.ratingTypeName]])</div>[[/if]]',
    '[[#if this.brand]]<div class="ppe-brand" style="font-size:11px;color:#888;">Brand: [[this.brand]]</div>[[/if]]',
    '</div>',
    '</div>',
    '[[/each]]',
    '</div>',
    '[[#if sample.ppeWarningText]]<div class="max-use-warning" style="padding:8px;border-radius:8px;margin-top:2px;font-size:12px;line-height:1.2;text-align:center;"><strong>[[sample.ppeWarningText]]</strong></div>[[/if]]',
    '</div>'
].join('');
